import { render, staticRenderFns } from "./hosted_consent.vue?vue&type=template&id=0ea94c40"
import script from "./hosted_consent.vue?vue&type=script&lang=js"
export * from "./hosted_consent.vue?vue&type=script&lang=js"
import style0 from "./hosted_consent.vue?vue&type=style&index=0&id=0ea94c40&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports